.loaderWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100px;
    padding: 12px 16px;
    gap: 8px;
    color: var(--theme-foreground, #1f2937);
    font-size: var(--font-size-sm, 14px);
    font-weight: var(--font-weight-medium, 500);
}

.spinner {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 3px solid var(--theme-border, #e5e7eb);
    border-top-color: var(--theme-primary, #3b82f6);
    animation: spin 850ms linear infinite;
}

.message {
    margin: 0;
    font-size: 0.875rem;
    color: inherit;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}